import { memo } from 'react';
import { InnerInstantPayeeForm } from '../../InstantPayeeForm';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ApReportFormInputInvoiceInstantPayee = memo((props) => (
  <InnerInstantPayeeForm {...props} />
)) as typeof InnerInstantPayeeForm;
ApReportFormInputInvoiceInstantPayee.displayName =
  'ApReportFormInputInvoiceInstantPayee';
